import React from "react";
import BalanceCard from "../../component/BalanceCard";
import Card from "../../component/Card";
import QuickMenuCard from "../../component/QuickMenuCard";
import { validFigureChecker } from "../../../../utils/helpers/dataHelper";

export default function SystemAdminDashboard({
  systemMetrics,
  transactionMetrics,
}) {
  const eventTotal = systemMetrics?.eventMetrics?.total;
  const communityTotal = systemMetrics?.communityMetrics?.total;
  const documentTotal = systemMetrics?.documentMetrics?.total;

  const paidTotal = transactionMetrics?.totalSuccessfulTransactions;
  const failedTotal = transactionMetrics?.totalFailedTransactions;
  const accountBalance = transactionMetrics?.totalSumOfSuccessfulTransactions;

  const merticsData = [
    {
      name: "Paid Transactions",
      total: validFigureChecker(paidTotal),
      fill: "green",
    },
    {
      name: "Failed Transactions",
      total: validFigureChecker(failedTotal),
      fill: "red",
    },
    { name: "Events", total: validFigureChecker(eventTotal), fill: "yellow" },
    {
      name: "Communities",
      total: validFigureChecker(communityTotal),
      fill: "blue",
    },
    {
      name: "Document",
      total: validFigureChecker(documentTotal),
      fill: "gray",
    },
  ];

  return (
    <div className="container mx-0 md:container md:mx-auto">
      <div className="page-header">
        <div>
          <h1 className="page-title">Dashboard</h1>
        </div>
      </div>
      <div className="">
        <BalanceCard name={"Account Balance"} accountBalance={accountBalance} />
        <QuickMenuCard name={"Quick Actions"} />
        <Card name={"Metrics"} data={merticsData} />
      </div>
    </div>
  );
}
